import _ from 'lodash';

import eeaCountryCodes from 'bundles/common/constants/EEACountryCodes';
import requestCountryCode from 'bundles/phoenix/template/models/requestCountryCode';

const exported = {
  /**
   * @param  {String} [cc] (e.g., 'US', 'UK')
   * @return {Boolean}
   */
  isEEA: (cc: string): boolean => _.includes(eeaCountryCodes, cc || requestCountryCode),
};

export default exported;

export const { isEEA } = exported;
